/* eslint-disable */
<template>
  <Modal 
    v-model="val"
    :width="800"
  >
    <div v-if="val">
      <h2 class="mb-m">磐石保經書面分析報告</h2>
      <div
        :style="{height: '600px',overflow: 'scroll'}"
      >
        <h3 
          class="mb-xs fz-small"
        >
          消費者基本資料
        </h3>
        <OddVerThTable 
          :rows="customerInfo"
          :className="`overflow-scroll fz-small mb-xs`"
        />        
          <h3 
            class="mb-xs mt-s fz-small"
          >
            保險需求
          </h3>
          <OddVerThTable 
            :rows="insuRequirement"
            :className="`overflow-scroll fz-small mb-xs min-width`"
          />          
        <h3 
          class="mb-xs mt-s fz-small"
        >
          本保險經紀人公司根據要保人/被保人所提供各種資訊及需求之建議內容
        </h3>
        <OddVerThTable 
          :rows="suggestConent"
          :className="`overflow-scroll fz-small mb-xs min-width`"
        />
        <h3   
          class="mb-xs mt-s fz-small"
        >
          保險金額
        </h3>
        <Table
          class="mb-s table-wrapper"
          :columns="insusDetail.columns"
          :data="insusDetail.details"
        />
        <h3 
          class="mb-xs mt-s fz-small"
        >
          備註
        </h3>
        <p 
          class="mb-s fz-tiny"
        >
          本分析報告並非保險契約之一部分，本分析報告所建議內容，保險公司是否予以承保及詳細保險商品內容、費率及變更，需以要保文件及投保當時保單條款和保險公司作業規則為準。
        </p>
        <p
          class="fz-tiny"
        >
          本分析報告係依據要、被保險人所提供各種資訊與需求所製作，並按製作時所可得之資訊而作出，本保險經紀人公司無法保證或承諾本分析報告內容完全正確無誤，抑或保險契約訂立後，將不因法令變更、金融保險市場變化或新金融保險相關資訊之衍生而有所變化或影響。
        </p>
      </div>
    </div>
    <div slot="footer" />
  </Modal>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import { Modal,Table } from 'iview';

  import format from 'date-fns/format';
  import differenceInCalendarISOYears from 'date-fns/difference_in_calendar_iso_years'

  import OddVerThTable from '@/components/tables/OddVerThTable';

  export default {
    components: { 
      Modal,
      Table,
      OddVerThTable
    },
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters(['userInfo']),
      ...mapState({
        checkout: ({ checkout }) => checkout,
        userProfile: ({ user }) => user.profile,
      }),
      val: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      },
      
      checkoutInfo() {
        const { checkout } = this;
        const { insuType } = checkout;
        switch (insuType) {
          case 'car':
            return checkout.infoOfCar;
            break;
          case 'motor':
            return checkout.infoOfMotor;
          break;
          case 'travel':
            return checkout.infoOfTravel;
          break;
          case 'accident':
            return checkout.infoOfAccident;
          break;
          case 'pet':
            return checkout.infoOfPet;
          break;
          case 'vaccine':
            return checkout.infoOfVaccine;
          break;
        }
      },
      customerInfo() {
        const { userInfo: {fullName,gender,age } ,userProfile } = this;
        const { identityNo,dateOfBirth: { year, month, day}} = userProfile;
        let data = [];
      
        data = [
           { title: '要保人', content: fullName },
           { title: '被保人', content: fullName },
           { title: '性別', content: gender.text },
           { title: '年齡', content: age },
        ]
        return data;
      },
      insuRequirement() {
        const { checkout,checkoutInfo } = this;
        const { insuType, insuInfos, travelInsuInfo:  {insuPeriod },accidentInsuInfo:{AccidentinsuPeriod},petInsuInfo:{PetinsuPeriod} } = checkout;//,vacccineInsuInfo:{VaccineinsuPeriod}
        let company = [];
        let insuTime = [];
        let product = [];
        let productIsCompulsory = [];
        const premiums = `${checkout.quotes.total} 元整`;
        insuInfos.filter((info) => {
          company.push(info.insuCompany);
          productIsCompulsory.push(info.isCompulsory);
          let productName = `${info.insuCompany}-${info.insuName}`
          product.push(productName);
        });
        const insuCompany = [...(new Set(company))][0];
        let data = [];
        switch (insuType) {
          case 'car':
            productIsCompulsory.filter((pclass) => {
              if(pclass) {
                let start = checkoutInfo.inceptionDate.compulsory;
                let end = (parseInt(start.split('-')[0])+1) + start.slice(4);
                insuTime.push(`強制險: (1年期) ${start} ~ ${end}`);
              }
              else{
                let comstart = checkoutInfo.inceptionDate.compulsory;
                let comend = (parseInt(comstart.split('-')[0])+1) + comstart.slice(4);
                insuTime.push(`強制險: (1年期) ${comstart} ~ ${comend}`);  //2020/5/18 Wen Add
                let start = checkoutInfo.inceptionDate.arbitrary;
                let end = (parseInt(start.split('-')[0])+1) + start.slice(4);
                insuTime.push(`任意險: (1年期) ${start} ~ ${end}`);
              }                
            }); 
            data = [
               { title: '是否有指定之保險公司？', content: `是，${insuCompany}`,thWidth: '60%' },
               { title: '保險期間', content: insuTime.join('|'), thWidth: '60%'},
               { title: '預估繳交保險費金額新台幣', content: premiums, thWidth: '60%'},
            ]
            return  data;
            break;
          case 'motor':
            productIsCompulsory.filter((pclass) => {
              if(pclass) {
                let start = checkoutInfo.inceptionDate.compulsory;
                let end = (parseInt(start.split('-')[0])+1) + start.slice(4);
                insuTime.push(`強制險: (1年期) ${start} ~ ${end}`);
              }
              else{
                /*let start = checkoutInfo.inceptionDate.arbitrary;
                let end = (parseInt(start.split('-')[0])+1) + start.slice(4);
                insuTime.push(`任意險: (1年期) ${start} ~ ${end}`);*/
                let comstart = checkoutInfo.inceptionDate.compulsory;
                let comend = (parseInt(comstart.split('-')[0])+1) + comstart.slice(4);
                insuTime.push(`強制險: (1年期) ${comstart} ~ ${comend}`);  //2020/5/18 Wen Add
                let start = checkoutInfo.inceptionDate.arbitrary;
                let end = (parseInt(start.split('-')[0])+1) + start.slice(4);
                insuTime.push(`任意險: (1年期) ${start} ~ ${end}`);
              }                
            }); 
            data = [
               { title: '是否有指定之保險公司？', content: `是，${insuCompany}`, thWidth: '60%' },
               { title: '保險期間', content: insuTime.join('|'), thWidth: '60%'},
               { title: '預估繳交保險費金額新台幣', content: premiums, thWidth: '60%'},
            ]
            return  data;
          break;
          case 'travel':
            const { travelNoticeData: { hasOtherInsu } } = checkoutInfo;
            const { desc, value } = hasOtherInsu;
            data = [
               { title: '是否有指定之保險公司？', content: `是，${insuCompany}`, thWidth: '60%' },
               { title: '保險期間', content: insuPeriod, thWidth: '60%' },
               { title: '被保險人於本次旅程是否已投保其他保險公司之旅行平安險？', content: `${value? '是，': '否'}${desc}`, thWidth: '60%'},
               { title: '預估繳交保險費金額新台幣', content: premiums, thWidth: '60%' },
            ]
            return  data;
          break;
          case 'accident':
            const { accidentNoticeData: { accidenthasOtherInsu }  } = checkoutInfo;
            //console.log("hasOtherAccidentInsu"+JSON.stringify(accidenthasOtherInsu));
            //const { desc1, value1} = accidenthasOtherInsu;
            const { accidentFilter } = checkoutInfo;
            //console.log("checkoutInfo--"+JSON.stringify(checkoutInfo));
            data = [
               { title: '是否有指定之保險公司？', content: `是，${insuCompany}`, thWidth: '60%' },
               { title: '保險期間', content: AccidentinsuPeriod, thWidth: '60%' },
               { title: '被保險人是否已投保其他保險公司之實支實付型醫療、傷害醫療保險？', content: `${accidenthasOtherInsu.value? '是，': '否'}${accidenthasOtherInsu.desc}`, thWidth: '60%'},
               { title: '預估繳交保險費金額新台幣', content: premiums, thWidth: '60%' },
               { title: '自動續保', content: `${accidentFilter.isbuy? '是，以信用卡付款': '否'}`, thWidth: '60%' },
            ]
            return  data;
          break;
          case 'pet':
            //const { accidentNoticeData: { accidenthasOtherInsu }  } = checkoutInfo;           
            //const { accidentFilter } = checkoutInfo;           
            data = [
               { title: '是否有指定之保險公司？', content: `是，${insuCompany}`, thWidth: '60%' },
               { title: '保險期間', content: PetinsuPeriod, thWidth: '60%' },               
               { title: '預估繳交保險費金額新台幣', content: premiums, thWidth: '60%' },              
            ]
            return data;
          break;
          case 'vaccine':                     
            data = [
               { title: '是否有指定之保險公司？', content: `是，${insuCompany}`, thWidth: '60%' },
               { title: '保險期間', content: insuPeriod, thWidth: '60%' },               
               { title: '預估繳交保險費金額新台幣', content: premiums, thWidth: '60%' },              
            ]
            return data;
          break;
        }
      },
      suggestConent() {
        const { checkout,checkoutInfo } = this;
        const { insuType, insuInfos } = checkout;
        let company = [];
        insuInfos.filter((info) => {
          company.push(info.insuCompany);
         // let companyUrl = info.InsucompUrl;
        });
        const insuCompany = [...(new Set(company))][0];
        //const insuName = insuType === 'travel'? '旅遊平安險' : insuType === 'car'? '汽車險': '機車險';
        //const insuName = insuType === 'travel'? '旅遊平安險' : insuType === 'car'? '汽車險': insuType === 'motor'?'機車險': insuType === 'accident'?'傷害險':'寵物險';
          const insuName = insuType === 'travel'? '旅遊平安險' : insuType === 'car'? '汽車險': insuType === 'motor'?'機車險': insuType === 'accident'?'傷害險':insuType === 'pet'?'寵物險':insuType === 'vaccine'?'疫苗險防疫險':'';
        const premiums = `${checkout.quotes.total} 元整`;
        const InsuCompanyUrl=checkout.quotes.insuCompanyUrl;
        //console.log("InsuCompanyUrl:"+InsuCompanyUrl);
        let data = [];
        data = [
          { title: '保險公司名稱', content: insuCompany },
          { title: '保險公司概況', content: '<a href="'+InsuCompanyUrl+'" target="_blank">'+InsuCompanyUrl+'</a>'},
          { title: '保險險種名稱', content: insuName },
          { title: '保障範圍', content: '詳保險契約條款'},
          { title: '保險費', content: premiums },
          { title: '建議投保保險公司理由', content: '客戶指定' }
        ]
        return data;
      },
      insusDetail() {
        const { checkout,checkout: {insuType} } = this;
        const details = checkout.quotes.details;
        let cols = [
          { title: '承保範圍', key: 'title' },
          { title: '保額', key: 'desc' },
          { title: '保費', key: 'amount' }
        ];
        if (insuType === 'travel' ||insuType === 'accident' ||insuType === 'pet' ||insuType === 'vaccine' ) {
          cols = cols.filter(col => col.key !== 'amount')
        }
        
        let data = {};
        data.details = details;
        data.columns = cols;
        return data;
      }
    }
  };
</script>